import { Injectable } from '@angular/core';
import { WorkCenterDsService, ActiveWorkCenterService } from '@app/core/workcenter';
import { AppSettingsQuery, ListValue } from 'chronos-shared';
import { Observable } from 'rxjs';
import { ProductionModeManual, QaCheck, ProductionMode } from 'chronos-core-client';
import { QaCheckDsService } from '@app/core/data-services';

@Injectable()
export class OutputContainerListService {
  constructor(
    private workCenterDsService: WorkCenterDsService,
    private activeWorkCenterService: ActiveWorkCenterService,
    private qaCheckDsService: QaCheckDsService,
    private appSettingsQuery: AppSettingsQuery
  ) {}

  public getQaSetupValues(productionOrderId: number): Observable<QaCheck[]> {
    return this.qaCheckDsService.getQaChecksForContainer(productionOrderId);
  }

  public getReasonOptions(): Observable<ListValue[]> {
    const workCenterId = this.activeWorkCenterService.getWorkCenterId();

    return this.workCenterDsService.getReasonOptions(workCenterId);
  }

  public getProductionMode(): Observable<ProductionMode> {
    return this.appSettingsQuery.productionMode$;
  }

  public getProductionModeManual(): Observable<ProductionModeManual> {
    return this.appSettingsQuery.productionModeManual$;
  }

  public isManualModeForContainer(): Observable<boolean> {
    return this.appSettingsQuery.isManualModeForContainer$;
  }
}
